// extracted by mini-css-extract-plugin
export default {"cartGrid":"cartGrid__NDFhN","firstDivider":"firstDivider__Mjg4Z"};